import { render, staticRenderFns } from "./BuyView.vue?vue&type=template&id=b35414a0&scoped=true"
import script from "./BuyView.vue?vue&type=script&lang=js"
export * from "./BuyView.vue?vue&type=script&lang=js"
import style0 from "./BuyView.vue?vue&type=style&index=0&id=b35414a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35414a0",
  null
  
)

export default component.exports